export enum SeAvatarType {
  Persona = 'persona',
  Org = 'org',
  Team = 'team'
}